var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLoggedIn)?_c('Login'):_vm._e(),(_vm.isLoggedIn)?_c('Main'):_vm._e(),(_vm.globalErr)?_c('TopWarning',{attrs:{"message":_vm.globalErr}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }